// extracted by mini-css-extract-plugin
export default {"rootLayout":"RootLayout_rootLayout__auIri","removeHeaderLogo":"RootLayout_removeHeaderLogo__P974p"};